export const withModelHeader = (headers = {}, model) => ({
  ...headers,
  ...(model ? { "X-OpenAI-Model": model } : {})
});
